export default __webpack_public_path__ + "static/media/krilnekapije5.4f630f89.jpg";